/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectGroupSimple
 */
export interface ReadOnlyMonitoredObjectGroupSimple {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroupSimple
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectGroupSimple
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectGroupSimple
     */
    color?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroupSimple
     */
    monitoredObjectGroupType?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroupSimple
     */
    client?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroupSimple
     */
    deleted: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectGroupSimple
     */
    automaticVehicleAdd?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectGroupSimple
     */
    readonly deletable?: boolean;
}

export function ReadOnlyMonitoredObjectGroupSimpleFromJSON(json: any): ReadOnlyMonitoredObjectGroupSimple {
    return ReadOnlyMonitoredObjectGroupSimpleFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectGroupSimpleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectGroupSimple {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'monitoredObjectGroupType': !exists(json, 'monitored_object_group_type') ? undefined : json['monitored_object_group_type'],
        'client': !exists(json, 'client') ? undefined : json['client'],
        'deleted': json['deleted'],
        'automaticVehicleAdd': !exists(json, 'automatic_vehicle_add') ? undefined : json['automatic_vehicle_add'],
        'deletable': !exists(json, 'deletable') ? undefined : json['deletable'],
    };
}

export function ReadOnlyMonitoredObjectGroupSimpleToJSON(value?: ReadOnlyMonitoredObjectGroupSimple | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'color': value.color,
        'monitored_object_group_type': value.monitoredObjectGroupType,
        'client': value.client,
        'deleted': value.deleted,
        'automatic_vehicle_add': value.automaticVehicleAdd,
    };
}


